import React from "react"
// import { Link } from "gatsby"
// import { css, Styled } from "theme-ui"
// import Header from "gatsby-theme-blog/src/components/header"

export default props => (
  <>
    {/*<Styled.a
      as={Link}
      to="/notes"
      css={css({
        ml: "auto",
        mr: "auto",
        fontFamily: "heading",
        fontWeight: "bold",
        textDecoration: "none",
        color: "inherit",
        ":hover": {
          textDecoration: "underline",
        },
      })}
    >
      Notes
    </Styled.a>*/}
    
    {/*<Styled.a
      as={Link}
      to="/blog"
      css={css({
        ml: "auto",
        mr: "auto",
        fontFamily: "heading",
        fontWeight: "bold",
        textDecoration: "none",
        color: "inherit",
        ":hover": {
          textDecoration: "underline",
        },
      })}
    >
      Blog
    </Styled.a>*/}
    
    {/*<Styled.a
      as={Link}
      to="/"
      css={css({
        ml: "auto",
        mr: "auto",
        fontFamily: "heading",
        fontWeight: "bold",
        textDecoration: "none",
        color: "inherit",
        ":hover": {
          textDecoration: "underline",
        },
      })}
    >
      Votre évaluation
    </Styled.a>*/}
    
    {/*<Styled.a
      as={Link}
      to="/quizz-bd"
      css={css({
        ml: "auto",
        mr: "auto",
        fontFamily: "heading",
        fontWeight: "bold",
        textDecoration: "none",
        color: "inherit",
        ":hover": {
          textDecoration: "underline",
        },
      })}
    >
      BD
    </Styled.a>*/}
  </>
)
